import { groupBy, mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';
import { AssemblyPlatePart, getAssemblyPlateParts } from './assemblyPartsUtilities';
import { getBundleByGuid } from './getBundleByGuid';
import { getProductionAnalysisSetComponentDesignByAnalysisSetGuid } from './getProductionAnalysisSetComponentDesignByAnalysisSetGuid';

const recordTrussQuantity = false;

export interface BundlePlatePartEntry {
  readonly bundleId: number;
  readonly bundleAssemblyPlateParts: readonly AssemblyPlatePart[];
}

export const getBundleAssemblyPlatePartEntriesByBundleGuid = createSelector(
  getBundleByGuid,
  (state: RootState) => state.productionModels.orderedProductionComponentInstancesByBundleGuid,
  getProductionAnalysisSetComponentDesignByAnalysisSetGuid,

  (
    bundlesByGuid,
    orderedProductionComponentInstancesByBundleGuid,
    productionAnalysisSetComponentDesignByAnalysisSetGuid,
  ): { [bundleGuid: string]: BundlePlatePartEntry } =>
    mapValues(bundlesByGuid, (bundle) => {
      const instancesForBundle = orderedProductionComponentInstancesByBundleGuid[bundle.guid];
      const analysisSetGuidQuantities = mapValues(
        groupBy(instancesForBundle, ({ analysisSetGuid }) => analysisSetGuid),
        (instances) => instances.length,
      );

      const bundlePlateParts: BundlePlatePartEntry = {
        bundleId: bundlesByGuid[bundle.guid].id,
        bundleAssemblyPlateParts: getAssemblyPlateParts(
          analysisSetGuidQuantities,
          productionAnalysisSetComponentDesignByAnalysisSetGuid,
          recordTrussQuantity,
        ),
      };
      return bundlePlateParts;
    }),
);
